import type { SVGAttributes } from 'react';

export function ActivityIcon(props: SVGAttributes<SVGSVGElement>) {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="none" {...props} viewBox="0 0 32 32">
			<path
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="2"
				d="M14.668 26h13.333m-13.333-9.333h13.333M14.668 7.333h13.333"
				opacity=".4"
			/>
			<path
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="2"
				d="m4 7.334 1.333 1.333 4-4M4 16.667 5.333 18l4-4M4 26l1.333 1.333 4-4"
			/>
		</svg>
	);
}
